import fetch from '@/utils/fetch';
import {systemFetch} from '@/utils/fetch';

// 登录
export function login(args) {
    const params = new URLSearchParams();
    params.append('account', args.account);
    params.append('password', args.password);

    return systemFetch({
        url: 'login/student',
        method: 'POST',
        data: params
    });
}

// 刷新
export function refresh(args) {
    const params = new URLSearchParams();
    params.append('token', args.token);

    return systemFetch({
        url: 'login/refresh',
        method: 'POST',
        params
    });
}

// 登出
export function logout(args) {
    const params = new URLSearchParams();
    params.append('token', args.token);

    return systemFetch({
        url: 'login/logout',
        method: 'POST',
        params
    });
}

// 获取当前学期
export function getCurrentSchoolTimeBySchoolId(args) {
    const params = new URLSearchParams();

    return fetch({
        url: 'structure/schoolTime/getCurrentSchoolTimeBySchoolId',
        method: 'POST',
        params
    });
}

export function getStudentInfo(args) {
    const params = new URLSearchParams();
    params.append('idsStr', args.idsStr);

    return systemFetch({
        url: 'api/user/student/info',
        method: 'POST',
        params
    });
}
export function fromOldFramework(userToken) {
    let params = new URLSearchParams();
    params.append('userToken', userToken);
    return systemFetch({
        url: 'login/fromOldFramework',
        method: 'GET',
        params
    });
}

export function permissions() {
    let params = new URLSearchParams();

    return systemFetch({
        url: 'oneself/permissions',
        method: 'GET',
        params
    });
}

/**
 * 微信登录：微信接口配置
 */
export function getWXInitData(){
    return systemFetch({
        url: 'login/weixin/permit',
        method: 'post'
    });
}

// 学生扫码方式
export function studentScanLogin(args) {
    const params = new URLSearchParams();
    if(args.code) {
        params.append('code', args.code);
    }
    if(args.studentId) {
        params.append('studentId', args.studentId);
    }
    if(args.wxToken) {
        params.append('wxToken', args.wxToken);
    }

    return systemFetch({
        url: 'login/studentScanLogin',
        method: 'GET',
        params
    });
}

/**
 * 微信登录：获得验证码(这个接口用来做绑定微信登录的时候使用)
 * @param {*} mobile
 */
export function getCode(mobile){
    let params = new URLSearchParams();
    params.append('mobile', mobile);
    params.append('userType', 3);

    return systemFetch({
        url: 'login/weixin/bind/getCode',
        method: 'post',
        data: params
    });
}

/**
 * 微信登录：绑定接口(先调用【微信登录：获得验证码】接口，引导客户输入收到的验证码后，调用此接口 如果成功后，会自动进行登录操作)
 * @param {*} code
 * @param {*} mobile
 * @param {*} wxToken
 */
export function  wxBind(code,mobile,wxToken){
    let params = new URLSearchParams();
    params.append('code', code);
    params.append('mobile', mobile);
    params.append('wxToken', wxToken);
    params.append('userType', 3);

    return systemFetch({
        url: 'login/weixin/bind',
        method: 'post',
        data: params
    });
}

/**
 * 选择学校登录
 * @param {*} account
 * @param {*} password
 * @param {*} schoolId
 */
export function loginForChosedSchoold(account, password,schoolId){
    let params = new URLSearchParams();
    params.append('account', account);
    params.append('password', password);
    params.append('schoolId', schoolId);
    return systemFetch({
        url: 'login',
        method: 'post',
        data: params
    });
}

/**
 * 登录的用户修改自己的密码
 * @param {*} newPwd
 * @param {*} oldPwd
 */
export function modifyPassword(newPwd,oldPwd,userId){
    let params = new URLSearchParams();
    params.append('newPwd', newPwd);
    params.append('oldPwd', oldPwd);
    params.append('userId', userId);
    return systemFetch({
        url: 'login/modifyPassword',
        method: 'post',
        data: params
    });
}

// 个人修改密码
export function changeStudent(args){
    let params = new URLSearchParams();
    params.append('newPwd', args.newPwd);
    params.append('oldPwd', args.oldPwd);

    return systemFetch({
        url: 'oneself/password/changeStudent',
        method: 'post',
        data: params
    });
}



// WEBPACK FOOTER //
// ./src/api/login.js